export default __webpack_public_path__ + "static/media/currychickpeas.51cc72af.jpg";